import DeletedComment from './DeletedComment'
import {Nullable} from '../../../app/TypeHelpers'

export default class DeletedCommentView extends DeletedComment {
    replyCount: number
    latestReplyDatetime: Nullable<string>

    constructor(meetingCommentId: number, message: string, replyCount: number, latestReplyDatetime: Nullable<string>) {
        super(meetingCommentId, message)
        this.replyCount = replyCount
        this.latestReplyDatetime = latestReplyDatetime
    }
}
